import { Card, PageHeader, Table, StatusBadge } from "../../components/shared/UIComponents";
import { STATS } from "../../data/initialData";

export default function Dashboard({ setActiveMenu, adminUser }) {
  return (
    <div>
      {adminUser && (
        <div style={{ background: "linear-gradient(135deg,#1565c0,#1a2744)", borderRadius: 12, padding: "20px 28px", marginBottom: 24, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 13 }}>Welcome back,</div>
            <div style={{ color: "#fff", fontSize: 22, fontWeight: 800 }}>{adminUser.name} 👋</div>
            <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 13, marginTop: 4 }}>{adminUser.society} · {adminUser.city}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ color: "#42a5f5", fontSize: 14, fontWeight: 700, fontFamily: "monospace", marginBottom: 6 }}>@{adminUser.username}</div>
            <StatusBadge status={adminUser.status || "Active"} />
          </div>
        </div>
      )}
      {!adminUser && <div style={{ marginBottom: 22 }}><h2 style={{ margin: "0 0 4px", fontSize: 20, color: "#1a2744", fontWeight: 700 }}>Dashboard</h2><p style={{ color: "#78909c", fontSize: 13 }}>Welcome back! Here's an overview of Ap IT Services.</p></div>}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16, marginBottom: 24 }}>
        {STATS.map(s => (
          <div key={s.label} style={{ background: "#fff", borderRadius: 12, padding: "20px 22px", boxShadow: "0 2px 12px rgba(0,0,0,0.06)", borderLeft: `4px solid ${s.color}` }}>
            <div style={{ fontSize: 26, fontWeight: 800, color: s.color, marginBottom: 4 }}>{s.value}</div>
            <div style={{ fontSize: 12, color: "#78909c", fontWeight: 500 }}>{s.label}</div>
          </div>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 20 }}>
        <Card>
          <PageHeader title="Recent Complaints" />
          <div style={{ padding: 16 }}>
            <Table columns={["Ticket No", "Flat", "Issue", "Status", "Date"]}
              rows={[
                { t: "TN18234", f: "F0202", i: "CCTV Camera not working", s: "Closed", d: "2025-09-09" },
                { t: "TN25853", f: "F0102", i: "Parking Problem", s: "InProgress", d: "2025-08-20" },
                { t: "TN45852", f: "F0202", i: "Water Leakage", s: "New", d: "2025-09-09" },
                { t: "TN67764", f: "F0202", i: "Lift Issue", s: "New", d: "2025-09-09" },
              ]}
              renderRow={(r) => [
                <td style={{ padding: "9px 12px", color: "#1565c0", fontWeight: 500 }}>{r.t}</td>,
                <td style={{ padding: "9px 12px" }}>{r.f}</td>,
                <td style={{ padding: "9px 12px" }}>{r.i}</td>,
                <td style={{ padding: "9px 12px" }}><StatusBadge status={r.s} /></td>,
                <td style={{ padding: "9px 12px", color: "#78909c" }}>{r.d}</td>,
              ]}
            />
          </div>
        </Card>
        <Card>
          <PageHeader title="Quick Links" />
          <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 8 }}>
            {[["Manage Members", "edit-member-details"], ["Notice Manager", "notice-manager"], ["Event Manager", "event-manager"], ["Upload Documents", "documents-manager"], ["Staff Management", "staff-management"], ["Sub Committee", "sub-committee"]].map(([label, id]) => (
              <button key={id} onClick={() => setActiveMenu(id)} style={{ padding: "10px 14px", background: "#f5f7fa", color: "#1565c0", border: "1px solid #e8eaf0", borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: "pointer", textAlign: "left" }}>→ {label}</button>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
